import { capitalize } from './functions/capitalize';
import { getOnlyNumber } from './functions/getOnlyNumbers';
import { getStringByContext } from './functions/getStringByContext';
import { replaceLastCommaWith } from './functions/replaceLastCommaWith';
import { slugify } from './functions/slugify';
import { textEllipsis } from './functions/textEllipsis';
import { toPascalCase } from './functions/toPascalCase';
String.prototype.toPascalCase = toPascalCase;
String.prototype.capitalize = capitalize;
String.prototype.slugify = slugify;
String.prototype.getStringByContext = getStringByContext;
String.prototype.replaceLastCommaWith = replaceLastCommaWith;
String.prototype.textEllipsis = textEllipsis;
String.prototype.getOnlyNumber = getOnlyNumber;
export default {};
//# sourceMappingURL=index.js.map